import Api from '@/modules/core/api/api.ts';
import { UserEndPoint } from '@/modules/common/enums/user-end-point.enum.ts';
import { RoleAdapter } from '@/modules/core/adapters/role.adapter.ts';

export default class UserApi {
  static async getId(): Promise<number> {
    const { login_id } = await Api.post(UserEndPoint.GetId);
    return login_id;
  }

  static async getName(id: number): Promise<string> {
    const { user_fio } = await Api.post(UserEndPoint.GetName, {
      login_id: id,
    });
    return user_fio;
  }

  static async getRoles() {
    const response = await Api.post(UserEndPoint.GetRoles);
    return RoleAdapter.mapList(response);
  }
}
